/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable import/named */
/* eslint-disable  */
import Cookies from 'js-cookie';
import React, { lazy } from 'react';
//import crypto from "crypto";
import CryptoJS from 'crypto-js';
import authRoutes from './authRoutes';
// import settingsNav from './settingsNav';
import { ReactComponent as CellIcon } from '../assets/svgIcons/sidebarNav/Cell-Icon.svg';
import { ReactComponent as ImportData } from '../assets/svgIcons/sidebarNav/ImportData.svg';
import { ReactComponent as VectorGlovalGiving } from '../assets/svgIcons/sidebarNav/VectorGlovalGiving.svg';
import { ReactComponent as TestIcon } from '../assets/svgIcons/sidebarNav/testicon.svg';
import { ReactComponent as TestIconActive } from '../assets/svgIcons/sidebarNav/testicon-active.svg';
import { ReactComponent as PracticeIcon } from '../assets/svgIcons/sidebarNav/practices-whitesvg.svg';
import { ReactComponent as PracticeIconActive } from '../assets/svgIcons/sidebarNav/practices-orangesvg.svg';
import { ReactComponent as NeuroIcon } from '../assets/svgIcons/sidebarNav/neuro-whitesvg.svg';
import { ReactComponent as NeuroIconActive } from '../assets/svgIcons/sidebarNav/neuro-orangesvg.svg';
import { ReactComponent as ClinicalIcon } from '../assets/svgIcons/sidebarNav/clinical-whitesvg.svg';
import { ReactComponent as ClinicalIconActive } from '../assets/svgIcons/sidebarNav/clinical-orangesvg.svg';
import { ReactComponent as SurveyIcon } from '../assets/svgIcons/sidebarNav/survey-whitesvg.svg';
import { ReactComponent as SurveyIconActive } from '../assets/svgIcons/sidebarNav/survey-orangesvg.svg';
import { ReactComponent as PatientIcon } from '../assets/svgIcons/sidebarNav/patients-whitesvg.svg';
import { ReactComponent as PatientIconActive } from '../assets/svgIcons/sidebarNav/patients-orangesvg.svg';
import { ReactComponent as MessagesIcon } from '../assets/svgIcons/sidebarNav/messages-whitesvg.svg';
import { ReactComponent as MessagesIconActive } from '../assets/svgIcons/sidebarNav/messages-orangesvg.svg';
import { ReactComponent as SettingsIcon } from '../assets/svgIcons/sidebarNav/settings-whitesvg.svg';
import { ReactComponent as SettingsIconActive } from '../assets/svgIcons/sidebarNav/settings-orangesvg.svg';
import { ReactComponent as ResourceOrange } from '../assets/svgIcons/sidebarNav/ResourceOrange.svg';
import { ReactComponent as ResourceWhite } from '../assets/svgIcons/sidebarNav/ResourceWhite.svg';
import { ReactComponent as Resource } from '../assets/svgIcons/sidebarNav/survey-whitesvg.svg';
import { ReactComponent as ReferralIcon } from '../assets/svgIcons/sidebarNav/blueReferral.svg';
import { ReactComponent as ReferralActiveIcon } from '../assets/svgIcons/sidebarNav/orangeReferral.svg';
// import { ReactComponent as AppointmentIcon } from '../assets/svgIcons/sidebarNav/appointment.svg';
// import { ReactComponent as CalendartIcon } from '../assets/svgIcons/sidebarNav/calendar.svg';
// import { ReactComponent as ClassestIcon } from '../assets/svgIcons/sidebarNav/classes.svg';
// import { ReactComponent as ClientstIcon } from '../assets/svgIcons/sidebarNav/clients.svg';
// import { ReactComponent as ReportstIcon } from '../assets/svgIcons/sidebarNav/reports.svg';
// import { ReactComponent as SalesIcon } from '../assets/svgIcons/sidebarNav/sales.svg';
// import { ReactComponent as StaffIcon } from '../assets/svgIcons/sidebarNav/staff.svg';
// import { ReactComponent as StudiosIcon } from '../assets/svgIcons/sidebarNav/studios.svg';
// import { ReactComponent as SettingsIcon } from '../assets/svgIcons/sidebarNav/settings.svg';

// const TimeZoneProvider = lazy(() => import('../contexts/timeZoneContext'));
// // const CompaniesProvider = lazy(() => import('../contexts/companiesContext'));
// const CompanyProvider = lazy(() => import('../contexts/companyContext'));
// const ClassCategoriesProvider = lazy(() => import('../contexts/classCategoriesContext'));
// const RevenueCategoriesProvider = lazy(() => import('../contexts/revenueCategoriesContext'));
// const TaxDetailsProvider = lazy(() => import('../contexts/taxDetailsContext'));
// const StateProvider = lazy(() => import('../contexts/stateContext'));
// const CancelPolicyProvider = lazy(() => import('../contexts/cancelPolicyContex'));

import { ReactComponent as GoalIcon } from '../assets/images/Goal.svg';
import { ReactComponent as FormTemplatesIcon } from '../assets/images/Forms-Template.svg';
import { ReactComponent as FormsIcon } from '../assets/images/Forms.svg';
import { ReactComponent as AnnouncementIcon } from '../assets/images/Announcement.svg';
import { ReactComponent as LearningIcon } from '../assets/images/Learning.svg';
import { ReactComponent as TrainingIcon } from '../assets/images/Training.svg';

import HomeIcon from '@material-ui/icons/Home';
import PersonIcon from '@material-ui/icons/Person';
import BusinessIcon from '@material-ui/icons/Business';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PublicIcon from '@material-ui/icons/Public';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import FinancialProgressionTest from '../screens/Main/Dashboard/FinancialProgressionTest/FinancialProgressionTest';
import FinancialProgression from '../screens/Main/Dashboard/FinancialProgression/FinancialProgression';
import QuarterlyMeetingObjectives from '../screens/Main/Dashboard/QuarterlyMeetingObjectives/QuarterlyMeetingObjectives';
import FinancialAnalysis from '../screens/Main/Dashboard/FinancialAnalysis/FinancialAnalysis';
import VectoHealthReportModel from '../screens/Main/Dashboard/VectoHealthReportModel/VectoHealthReportModel';
import EmployeePerformance from '../screens/Main/Dashboard/EmployeePerformance';
import EmployeeScoreTable from '../screens/Main/Dashboard/EmployeeScoreTable';
import EmployeePerformanceTest from '../screens/Main/Dashboard/EmployeePerformanceTest/EmployeePerformanceTest';
import ProfitQb from '../screens/Main/Dashboard/ProfitQb/ProfitQb';
import AccountAnalysis from '../screens/Main/Dashboard/AccountAnalysis';
import SummaryInvoiceByCell from '../screens/Main/Dashboard/SummaryInvoiceByCell/SummaryInvoiceByCell';
import SummaryInvoiceByCountry from '../screens/Main/Dashboard/SummaryInvoiceByCountry/SummaryInvoiceByCountry';
import CollectionReport from '../screens/Main/Dashboard/CollectionReport/CollectionReport';
import CollectionReportAll from '../screens/Main/Dashboard/CollectionReportAll/CollectionReportAll';
import CellWorkLoadNumbers from '../screens/Main/Dashboard/CellWorkLoadNumbers/CellWorkLoadNumbers';
import CellWorkLoad from '../screens/Main/Dashboard/CellWorkLoad/CellWorkLoad';
import SummaryTab from '../screens/Main/Dashboard/SummaryTab/SummaryTab';
import EmployeeAnalysisTab from '../screens/Main/Dashboard/EmployeeAnalysisTab/EmployeeAnalysisTab';
import MyPerformanceTab from '../screens/Main/Dashboard/MyPerformanceTab/MyPerformanceTab';
import HistoricPerformanceTable from '../screens/Main/Dashboard/HistoricPerformanceTable/HistoricPerformanceTable';
import MyPersonalPerformance from '../screens/Main/Dashboard/MyPersonalPerformance/MyPersonalPerformance';
import MyPerformanceSalesUser from '../screens/Main/Dashboard/MyPerformanceSalesUser/MyPerformanceSalesUser';
import dashboardRoutes from './dashboardRoutesV2';

let userType = '';
let appNav = [];
const ComingSoon = lazy(() => import('../screens/Main/ComingSoon'));
const EmployeeDirectory = lazy(() => import('../screens/Main/EmployeeDirectory'));
const ViewEmployeeDetails = lazy(() => import('../screens/Main/ViewEmployeeDetails'));
const ViewFormDetails = lazy(() => import('../screens/Main/ViewFormDetails'));
const AccountDirectoryDetail = lazy(() =>
  import('../screens/Main/AccountDirectory/AccountDirectoryDetail'),
);
const Dashboard = lazy(() => import('../screens/Main/Dashboard'));
const CellPerformanceCharts = lazy(() =>
  import('../screens/Main/Dashboard/CellPerformanceCharts/CellPerformanceCharts'),
);
const CompanyGoals = lazy(() => import('../screens/Main/Dashboard/CompanyGoals/CompanyGoals'));
const CellGoals = lazy(() => import('../screens/Main/Dashboard/CellGoals/CellGoals'));
const CountriesOperationalPerformanceLogiware = lazy(() =>
  import(
    '../screens/Main/Dashboard/CountriesOperationalPerformanceLogiware/CountriesOperationalPerformanceLogiware'
  ),
);
const MyGoals = lazy(() => import('../screens/Main/Dashboard/MyGoals/MyGoals'));
const QuarterlyReoprt = lazy(() => import('../screens/Main/Dashboard/QuarterlyMeetingObjectives'));
const LearningOpportunities = lazy(() => import('../screens/Main/LearningOpportunities'));
const FormTemplate = lazy(() => import('../screens/Main/FormTemplate'));
const Forms = lazy(() => import('../screens/Main/Forms'));
const Announcements = lazy(() => import('../screens/Main/Announcements'));
const GlobalGivingCauses = lazy(() => import('../screens/Main/GlobalGivingCauses'));
const TrainingResources = lazy(() => import('../screens/Main/TrainingResources'));
const AccountDirectory = lazy(() => import('../screens/Main/AccountDirectory'));
const CalendarNotification = lazy(() => import('../screens/Main/CalendarNotification/'));
const CalendarDashboardView = lazy(() =>
  import('../screens/Main/CalendarNotification/CalendarDashboardView'),
);
const QuickBookAccess = lazy(() =>
  import('../screens/Main/Dashboard/QuickBookAccess/QuickBookAccess'),
);

const TotalFilesNotes = lazy(() =>
  import('../screens/Main/Dashboard/TotalFilesNotes/TotalFilesNotes'),
);
const Goals = lazy(() => import('../screens/Main/Goals'));
const GoalDetails = lazy(() => import('../screens/Main/Goals/GoalDetails'));
const PerformanceSummaryReport = lazy(() =>
  import('../screens/Main/Dashboard/PerformanceSummaryReport'),
);
const Referrals = lazy(() => import('../screens/Main/Refferals'));
const Message = lazy(() => import('../screens/Main/Message'));
const NewMessage = lazy(() => import('../screens/Main/NewMessage'));
const AdminResources = lazy(() => import('../screens/Main/AdminResources'));
const WaterMark = lazy(() => import('../screens/Main/WaterMark'));
// const NeuroDrillDown = lazy(() => import('../screens/Main/NeuroDrillDown'));
const IntroSection = lazy(() => import('../screens/Main/IntroSection'));
const Country = lazy(() => import('../screens/Main/CountryList'));
const Cell = lazy(() => import('../screens/Main/CellList'));
const Test = lazy(() => import('../screens/Main/Test'));
const FormDetail = lazy(() => import('../screens/Main/FormDetail'));
const VectorHealthReport = lazy(() => import('../screens/Main/VectorHealthReport'));
const VectorHealthQuestionReport = lazy(() => import('../screens/Main/VectorHealthQuestionReport'));
const UpdatePassword = lazy(() => import('../screens/Auth/UpdatePassword'));
const MyCellTab = lazy(() => import('../screens/Main/Dashboard/MyCellTab/MyCellTab'));
// const Settings = lazy(() => import('../screens/Main/Settings'));
const key = 'iFrasCwdJh';
const userCookie = Cookies.get('user');
let userData = [];
if (userCookie) {
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  userData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

  userType = (userData?.userType && userData?.userType?.type) || null;
} else {
  if (
    window.location.href.indexOf('set-password') < 0 &&
    window.location.href.indexOf('forgot-password') < 0 &&
    window.location.href.indexOf('reset-password') < 0 &&
    window.location.href.indexOf('two-factor-authentication') < 0 &&
    window.location.href.indexOf('create-account') < 0
  ) {
    // window.location = '/#/login';
    /*to pass no authorization urls*/
    let noAuthUrls = ['dialogstable']; // add urls here to access without auth
    let urlIndex = noAuthUrls.filter((responses) => window.location.href.indexOf(responses) > -1);
    /*to pass no authorization urls*/
    console.log(urlIndex, 121);

    if (!urlIndex || !urlIndex.length) {
      window.location = '/#/login';
    } else {
      appNav = [
        {
          name: 'Dialogs Table',
          /* navImage: require('../assets/images/staff.png').default, */
          image: require('../assets/images/staff.png').default,
          navIcons: <TestIconActive />,
          path: 'dialogstable',
          element: null,
          navIconsAlt: <TestIcon />,
        },
      ];
    }
  }
}

if (userData?.isChangedPassword != 0) {
  appNav = [
    {
      name: 'Landing',
      path: '',
      element: <WaterMark />,
    },
    {
      name: 'Dashboard',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'dashboard',
      element: <Dashboard />,
      navIconsAlt: <HomeIcon />,
      num: 1,
      children: dashboardRoutes,
    },
    {
      name: 'Performance Summary Report',
      /* navImage: require('../assets/images/staff.png').default, */
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'dashboard/performance-review-summary-report/:formTrackerId/:userId/:year',
      element: <PerformanceSummaryReport />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb',
      element: <QuickBookAccess />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'MyPerformanceSalesUser',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'workload',
      element: <SummaryTab />, //MyPerformanceSalesUser CellWorkLoad SummaryTab EmployeeAnalysisTab
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'MyCellTab',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'mycell',
      element: <MyCellTab />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb1',
      element: <CollectionReportAll />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb2',
      element: <EmployeePerformance />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb3',
      element: <SummaryInvoiceByCell />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb4',
      element: <FinancialProgressionTest />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'qb5',
      element: <CollectionReport />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'VectoHealthReportModel',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'test',
      element: <VectoHealthReportModel />,
      navIconsAlt: <HomeIcon />,
      num: 0,
    },
    {
      name: 'View Employee',
      /* navImage: require('../assets/images/staff.png').default, */
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-employee/:userId/:countryId',
      element: <ViewEmployeeDetails />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'View Form Quetion',
      /* navImage: require('../assets/images/staff.png').default, */
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-form-questions/:formId/',
      element: <ViewFormDetails />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'Employee Directory',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <PersonIcon />,
      path: 'employee-directory/:formId',
      element: <EmployeeDirectory />,
      navIconsAlt: <PersonIcon />,
      num: 1,
    },
    {
      name: 'CalendarNotification',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <PersonIcon />,
      path: 'calendarnotification',
      element: <CalendarNotification />,
      navIconsAlt: <PersonIcon />,
    },
    {
      name: 'Client Directory',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <BusinessIcon />,
      path: 'client-directory',
      element: <AccountDirectory />,
      navIconsAlt: <BusinessIcon />,
      num: 1,
    },
    {
      name: 'Client Directory Detail',
      /* navImage: require('../assets/images/staff.png').default, */
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-client-directory/:accountId/:countryId',
      element: <AccountDirectoryDetail />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'Goals',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <GoalIcon />,
      path: 'goals',
      element: <Goals />,
      navIconsAlt: <GoalIcon />,
      num: 1,
    },
    {
      name: 'Goal Details',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <GoalIcon />,
      path: 'goal-details/:id/:type/:year/:goalyear',
      element: <GoalDetails />,
      navIconsAlt: <GoalIcon />,
    },
    {
      name: 'Form Templates',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <FormTemplatesIcon />,
      path: 'form-template/:receivedFormId/:userId',
      element: <FormTemplate />,
      navIconsAlt: <FormTemplatesIcon />,
      num: 1,
    },
    {
      name: 'Forms',
      image: require('../assets/images/Forms.svg').default,
      navIcons: <FormsIcon />,
      path: 'forms/:id',
      element: <Forms />,
      navIconsAlt: <FormsIcon />,
      num: 1,
    },
    {
      name: 'Announcements',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <AnnouncementIcon />,
      path: 'announcements',
      element: <Announcements />,
      navIconsAlt: <AnnouncementIcon />,
      num: 1,
    },
    {
      name: 'Learning Opportunities',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <LearningIcon />,
      path: 'learning-opportunities',
      element: <LearningOpportunities />,
      navIconsAlt: <LearningIcon />,
      num: 1,
    },
    {
      name: 'Global Giving',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <VectorGlovalGiving />,
      path: 'global-giving-causes',
      element: <GlobalGivingCauses />,
      navIconsAlt: <VectorGlovalGiving />,
      num: 1,
    },
    {
      name: 'Training Resources',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <TrainingIcon />,
      path: 'training-resources',
      element: <TrainingResources />,
      navIconsAlt: <TrainingIcon />,
      num: 1,
    },
    {
      name: 'Country',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <PublicIcon />,
      path: 'country-list',
      element: <Country />,
      navIconsAlt: <PublicIcon />,
      num: 1,
    },
    {
      name: 'Cells',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <CellIcon />,
      path: 'cell-list',
      element: <Cell />,
      navIconsAlt: <CellIcon />,
      num: 1,
    },
    {
      name: 'Update Password',
      image: require('../assets/images/dashboard.png').default,
      //navIcons: <PublicIcon />,
      path: 'update-password',
      element: <UpdatePassword />,
      //navIconsAlt: <PublicIcon />,
      //num: 1,
    },
    {
      name: 'Form Detail',
      path: 'form-detail',
      element: <FormDetail />,
    },

    {
      name: 'Vector Health Report',
      /* navImage: require('../assets/images/staff.png').default, */
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-vector-health-report',
      element: <VectorHealthReport />,
      navIconsAlt: <HomeIcon />,
    },

    {
      name: 'Vector Health Question Report',
      image: require('../assets/images/dashboard.png').default,
      navIcons: <HomeIcon />,
      path: 'view-vector-question-health-report/:qid/:qnumber/:value',
      element: <VectorHealthQuestionReport />,
      navIconsAlt: <HomeIcon />,
    },
    {
      name: 'Import Data Tool',
      /* image: require('../assets/images/dashboard.png').default, */
      navIcons: <ImportData />,
      path: 'import-data',
      element: <Test />,
      navIconsAlt: <ImportData />,
      num: 1,
    },
  ];
} else {
  appNav = [
    // {
    //   name: 'Landing',
    //   path: 'update-password',
    //   element: <WaterMark />,
    // },

    {
      name: 'Update Password',
      image: require('../assets/images/dashboard.png').default,
      //navIcons: <PublicIcon />,
      path: 'update-password',
      element: <UpdatePassword />,
      //navIconsAlt: <PublicIcon />,
      //num: 1,
    },
  ];
}

export default appNav;
